import { Address } from '@api/generated/graphql';

type AddressToFormat = Omit<Address, 'latitude' | 'longitude'>;

/**
 * Formats a customer address into a string representation.
 * @param address - The customer address object.
 * @returns The formatted address string. Example: "123 Main St, Anytown, CA 12345 US"
 */
const formatAddress = (address: AddressToFormat): string => {
  let formattedAddress = `${address.street}`;
  formattedAddress += address.unit ? `, ${address.unit}` : '';
  formattedAddress += address.city ? `, ${address.city}` : '';
  formattedAddress += address.state ? `, ${address.state}` : '';
  formattedAddress += address.zip ? ` ${address.zip}` : '';
  formattedAddress += address.country ? ` ${address.country}` : '';
  return formattedAddress.trim();
};

export default formatAddress;

export const formatAddressMultiline = (address: AddressToFormat): string => {
  const formattedAddress = [];
  formattedAddress.push(
    [address.street, address.unit].filter(Boolean).join(', '),
  );
  formattedAddress.push(
    [address.city, address.state, address.zip].filter(Boolean).join(', '),
  );
  formattedAddress.push(address.country);
  return formattedAddress.filter(Boolean).join('\n');
};
